import { configureStore } from "@reduxjs/toolkit";
import AuthSlice from "./AuthSlice";
import EmployeesSlice from "./EmployeesSlice";
import SettingsSlice from "./SettingsSlice";
import SharedSlice from "./SharedSlice";

export default configureStore({
  reducer: {
    AuthSlice,
    EmployeesSlice,
    SettingsSlice,
    SharedSlice,
  },
});
